import Section from "components/Section";
import React, { useMemo } from "react";
import styles from "./styles.module.scss";

import Title from "components/Title";
import Card from "containers/Card";
import urls from "utils/urls";

const Services: React.FC = () => {
  const steps = useMemo(
    () => [
      {
        image: urls.images("services/installation.png"),
        title: "Solar Rooftop Installations",
        description:
          "Efficient, high-quality solar rooftop installations tailored to maximize energy savings.",
      },
      {
        image: urls.images("services/design.png"),
        title: "Solar Engineering and Design",
        description:
          "Innovative solar engineering and design solutions for efficient, sustainable energy systems.",
      },
      {
        image: urls.images("services/solutions.png"),
        title: "Solar Technology Solutions",
        description:
          "Comprehensive solar technology supply not only for street lighting, battery charging, and water pumping.",
      },
      {
        image: urls.images("services/consulting.png"),
        title: "Renewable Energy Consulting",
        description:
          "Expert renewable energy consulting to help you navigate sustainable solutions and optimize energy efficiency.",
      },
      {
        image: urls.images("services/development.png"),
        title: "RE Project Development",
        description:
          "End-to-end renewable energy project development, from feasibility studies to successful implementation and operation.",
      },
      {
        image: urls.images("services/management.png"),
        title: "Operations & Maintenance",
        description:
          "Reliable upkeep and management for peak solar system performance across all sectors.",
      },
    ],
    []
  );

  return (
    <Section id="services" label="Services">
      <Title
        className={styles.title}
        title="<highlight>Our Solutions</highlight> tailored for you"
      />

      <div className={styles.list}>
        {steps.map((step) => (
          <Card
            className={styles.card}
            description={step.description}
            icon={step.image}
            key={step.title}
            title={step.title}
          />
        ))}
      </div>
    </Section>
  );
};

export default Services;
